import React from 'react';
import './../../../Styles/Main/RentalPage/RentalBikeCard.scss';
import MyButton from '../../../UI/button/MyButton';
import { useState } from 'react';
import { aluminiumBikes, carbonBikes, cityBikes, mtbBikes, bikesBrend, bikesFrameSize, rentalRequestRoute } from './../../../Constant/index';


function RentalBikeCard({ takeBikeNumber, ...props }) {

   const [isSelected, setIsSelected ] = useState(false);

   const selectedBike = (e) => {
      let numberBikeCard = e.closest('.rentalBikeCard__button').classList[1];
      isSelected ? setIsSelected(false) : setIsSelected(true);
      takeBikeNumber(numberBikeCard, isSelected)
   }

   return (
      <div className='rentalBikeCard__wrapper'>
         <div className="rentalBikeCard__body">
            <div className="rentalBikeCard__title">
               <div className="rentalBikeCard__size signature">{ props.size }</div>
               <div className="rentalBikeCard__brend signature">{ props.brend }</div>
            </div>
            <div className="rentalBikeCard__image">
               <img src={"./image/" + props.image} alt=""/>
            </div>
            <div className="rentalBikeCard__typeBike text">
               { props.typeBike }
            </div>
            <div className="rentalBikeCard__fullName text">
               {props.fullName}
            </div>
            <div className="rentalBikeCard__price color-text">{ props.price }</div>
            <div className={["rentalBikeCard__button", `${props.number}`].join(' ')}>
               <MyButton
                  style={{
                     fontSize: '20px',
                     fontWeight: '700',
                     backgroundColor: props.state ? "#fff" : "#297FFF",
                     color: props.state ? "#297FFF" : "#fff",
                     border: props.state ? "1px solid #297FFF" : "1px solid #fff",
                  }}
                  onClick={e=>selectedBike(e.target)}
               >
                  Select
               </MyButton>
            </div>
         </div>
      </div>
   );
}
export default RentalBikeCard;